const cargoData = Array.from({ length: 50 }, (_, i) => ({
  id: i + 1,
  companyName: `Cargo Company ${i + 1}`,
  contactPerson: `Person ${i + 1}`,
  email: `cargo${i + 1}@example.com`,
  website: `www.cargo${i + 1}.com`,
  mobile: `98000000${String(i + 1).padStart(2, "0")}`,

  district: "Kathmandu",
  municipality: "Kathmandu Metropolitan",
  localArea: "Baneshwor",

  destinationDistrict: "Pokhara",
  destinationMunicipality: "Pokhara Metro",
  destinationLocalArea: "Lakeside",

  serviceArea: "All Nepal",
  courierService: "Cargo Service",

  transportType: ["Van", "Truck", "Plane", "Bike"][i % 4],

  availableSpace: "300kg",
  itemQuota: `${10 + i} items`,

  length: "100cm",
  breadth: "80cm",
  height: "60cm",

  pricePerKg: 40 + i,
  pricePerItem: 80 + i,
  priceWholeSpace: 4000 + i * 20,

  departTime: "10:00 AM",
  deliveryTime: `${1 + (i % 4)} Days`
}));

export default cargoData;